<template>
  <v-card
    class="manager-dialog"
  >
    <v-container
      v-if="approvalRequest.status === 'PENDING'"
      class="pa-0 ma-0"
    >
      <v-card-title
        class="manager-dialog__title pa-0"
      >
        Solicitação de alteração de valor enviado para a gerência. Aguarde resposta.
      </v-card-title>
      <Loader
        :size="70"
        class="pa-2 mb-4 mt-3"
      />
      <v-card-actions class="manager-dialog__content pa-0 ma-0">
        <v-btn
          dark
          color="#140C22"
          class="manager-dialog__btn"
          @click="cancelRequest()"
        >
          Cancelar solicitação
        </v-btn>
      </v-card-actions>
    </v-container>

    <v-container
      v-if="approvalRequest.status === 'APPROVED'"
      class="pa-0 ma-0"
    >
      <div class="animation-container">
        <div class="animation-container__circle-border" />
        <div class="animation-container__circle">
          <div class="animation-container__success" />
        </div>
      </div>
      <v-card-title
        class="animation-container__title"
      >
        Solicitação aceita com sucesso!
      </v-card-title>
      <v-card-actions class="animation-container__content pa-0 ma-0">
        <v-btn
          dark
          color="#140C22"
          class="animation-container__btn"
          @click="close()"
        >
          Voltar
        </v-btn>
      </v-card-actions>
    </v-container>

    <v-container
      v-if="approvalRequest.status === 'DECLINED'"
      class="pa-0 ma-0"
    >
      <div class="denied-container">
        <div class="denied-container__circle-border" />
        <div class="denied-container__circle">
          <div class="denied-container__success" />
        </div>
      </div>

      <v-card-title
        class="denied-container__title"
      >
        Solicitação negada. Converse com a gerência para entender o motivo.
      </v-card-title>

      <v-card-actions class="denied-container__content pa-0 ma-0">
        <v-btn
          dark
          color="#140C22"
          class="denied-container__btn"
          @click="close()"
        >
          Voltar
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import { useZipperApi } from '@/composables/useZipperApi';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { EventBus } from '@/event-bus.js';

const { client } = useZipperApi();

export default {
  props: {
    approvalRequest: {
      type: Object,
      default: () => {},
    },
    finalPrice: {
      type: Number,
      default: 0,
    },
    close: {
      type: Function,
      default: () => {},
    },
    emitSnackbar: {
      type: Function,
      default: () => {},
    },
  },

  watch: {
    approvalRequest: {
      handler() {
        this.changeStatusRequest(this.approvalRequest._id);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    cancelRequest() {
      this.deleteApprovalRequest(this.approvalRequest._id);
      this.close();
    },

    async changeStatusRequest(approvalRequestId) {
      const approvalRequest = await client.chain.query
        .getApprovalRequestById({
          approvalRequestId,
        })
        .get({ status: true });

      if (!approvalRequest) return;

      this.$set(this.approvalRequest, 'status', approvalRequest.status);

      if (approvalRequest.status === 'APPROVED') {
        EventBus.$emit('addDiscount', this.finalPrice);
        this.emitSnackbar('Valor do produto alterado com sucesso');
      } else if (approvalRequest.status === 'PENDING') {
        await this.changeStatusRequest(approvalRequestId);
      }
    },

    async deleteApprovalRequest(approvalRequestId) {
      await client.chain.mutation.deleteApprovalRequest({
        approvalRequestId,
      }).get({ _id: true });
    },
  },
};
</script>

<style scoped lang="scss">

.manager-dialog {
padding: 30px 14px 30px 14px;
text-transform: none;
border-radius: 7px;
&__title {
font-family: 'Nunito Sans';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 22px;
text-align: center;
}
&__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
&__btn {
  width: 141px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-size: 12px;
  line-height: 14px;
  border-radius: 4px;
  text-transform: none;
}
}
$circle-size: 60px;
$color-green: #77c861;
$color-red: #FF5146;
.animation-container {
  background-color: white;
  height: 48px;
  width: 275px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  &__title {
  font-family: 'Nunito Sans';
  font-weight: 600;
  font-style: normal;
  line-height: 22px;
  font-size: 16px;
  text-align: center;
  padding: 20px 30px 30px;
  }
  &__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
  &__btn {
  width: 65px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-size: 12px;
  line-height: 14px;
  border-radius: 4px;
  text-transform: none;
}
  &__circle, &__circle-border {
  width: $circle-size;
  height: $circle-size;
  border-radius: 50%;
  }
  &__circle {
  z-index: 1;
  position: relative;
  background: white;
  transform: scale(1);
  animation: success-anim 700ms ease;
  }
  &__circle-border {
  z-index: 0;
  position: absolute;
  background: $color-green;
  transform: scale(1.1);
  animation: circle-anim 400ms ease;
  }
  &__success {
   &::before, &::after {
     display: block;
     content: '';
     background: $color-green;
     height: 4px;
     position: absolute;
    }
    &::before {
    width: 17px;
    top: 58%;
    left: 23%;
    transform: rotateZ(50deg);
    }
    &::after {
    width: 30px;
    top: 50%;
    left: 35%;
    transform: rotateZ(-50deg);
    }
  }
}

.denied-container {
  background-color: white;
  height: 48px;
  width: 275px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  &__title {
  font-family: 'Nunito Sans';
  font-weight: 600;
  font-style: normal;
  line-height: 22px;
  font-size: 16px;
  text-align: center;
  padding: 20px 0px 30px;
  }
  &__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
  &__btn {
  width: 65px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-size: 12px;
  line-height: 14px;
  border-radius: 4px;
  text-transform: none;
}
  &__circle, &__circle-border {
  width: $circle-size;
  height: $circle-size;
  border-radius: 50%;
  }
  &__circle {
  z-index: 1;
  position: relative;
  background: white;
  transform: scale(1);
  animation: success-anim 700ms ease;
  }
  &__circle-border {
  z-index: 0;
  position: absolute;
  background: $color-red;
  transform: scale(1.1);
  animation: circle-anim 400ms ease;
  }
  &__success {
   &::before, &::after {
     display: block;
     content: '';
     background: $color-red;
     height: 4px;
     position: absolute;
    }
    &::before {
    width: 35px;
    top: 50%;
    left: 22%;
    transform: rotateZ(45deg);
    }
    &::after {
    width: 35px;
    top: 50%;
    left: 22%;
    transform: rotateZ(-45deg);
    }
  }
}
@keyframes success-anim {
  0% {
    transform: scale(0);
  }
  30% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes circle-anim {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1.1);
  }
}
</style>
